module.exports = "//public.zight.com/packs/media/images/pro-ribbon-b402b783a6286872f5f77b50fb05f9f7.svg";